import { render, staticRenderFns } from "./PreregistrationTable.vue?vue&type=template&id=10ba4e25"
import script from "./PreregistrationTable.vue?vue&type=script&lang=js"
export * from "./PreregistrationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports